import { identity } from 'lodash';
import { useMemo } from 'react';
import meetingState from '../../constants/meetingState';
import { useMyUserId } from '../sessionHooks';
import { useEventParticipantsList } from '../participant/useEventParticipantsList';

export function useIsMeetingReschedulable(eventId, meeting) {
    const selfId = useMyUserId(),
        referredUsers = useMemo(() => [...(meeting?.invited.map((invitee) => invitee.user_id) || []), meeting?.initiator.id].filter(identity).filter((id) => id != selfId), [meeting, selfId]),
        users = useEventParticipantsList(
            eventId,
            referredUsers.map((id) => ({ userId: id }))
        );

    // only if length == 1 because rescheduling of groups (>1) is not allowed, but < 1 is invalid
    return users.length == 1 && [meetingState.PENDING, meetingState.CONFIRMED].includes(meeting._state);
}
